// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2031":"097841326d5edba9","4941":"b5402cd96be27885"}[chunkId] + ".js";
};